var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 8,
    viewBox: "0 0 4 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.79668 7.17124L0.149245 5.34884C0.0258527 5.21234 0.0263119 4.99155 0.150322 4.85568C0.274317 4.71982 0.474872 4.72034 0.59828 4.85684L1.70414 6.08019V1.07576C1.70414 0.883169 1.84596 0.727051 2.0209 0.727051C2.19585 0.727051 2.33766 0.883169 2.33766 1.07576V6.08017L3.44352 4.85686C3.56693 4.72036 3.76748 4.71984 3.89148 4.85569C4.0155 4.99157 4.01593 5.21237 3.89255 5.34886L2.24542 7.17094C2.1216 7.30751 1.92009 7.30739 1.79668 7.17124Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/DownArrow.11509010989c9798c1428a6bf2abfa48.svg";
export { ForwardRef as ReactComponent };